import React from 'react';
import { FiFileText } from 'react-icons/fi';

const WritingBlockEditor = ({ block, onUpdate }) => {
    const taskDescription = block.taskDescription || '';
    const minWords = block.minWords || 150;
    const maxWords = block.maxWords || 300;
    const maxPoints = block.maxPoints || 20;

    return (
        <div style={{ display: 'grid', gap: '20px' }}>
            <div style={{ 
                padding: '15px', 
                background: '#fff7e6', 
                border: '1px solid #ffd591', 
                borderRadius: '8px',
                fontSize: '13px',
                color: '#ad6800'
            }}>
                <strong>ℹ️ Важно:</strong> Блок письма требует ручной проверки преподавателем. 
                После завершения теста студент увидит результаты по остальным блокам, 
                но итоговый балл будет доступен только после проверки письма.
            </div>

            {/* Описание задания */}
            <div>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                    Описание задания *
                </label>
                <p style={{ fontSize: '12px', color: '#999', marginBottom: '8px' }}>
                    Подробно опишите задание. Что должен написать студент?
                </p>
                <textarea
                    value={taskDescription}
                    onChange={(e) => onUpdate({ taskDescription: e.target.value })}
                    rows={6}
                    placeholder={`Например:\n\nWrite an essay about your favorite city. Include the following points:\n1. Why do you like this city?\n2. What places would you recommend to visit?\n3. What makes this city special?\n\nUse appropriate vocabulary and grammar structures. Write 150-300 words.`}
                    style={{ 
                        width: '100%', 
                        padding: '12px', 
                        border: '1px solid #ddd', 
                        borderRadius: '6px',
                        fontFamily: 'inherit',
                        fontSize: '14px',
                        lineHeight: '1.6'
                    }}
                />
            </div>

            {/* Параметры письма */}
            <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(3, 1fr)', 
                gap: '15px',
                padding: '20px',
                background: '#f9f9f9',
                borderRadius: '8px',
                border: '1px solid #e0e0e0'
            }}>
                <div>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', fontSize: '13px' }}>
                        Минимум слов
                    </label>
                    <input
                        type="number"
                        value={minWords}
                        onChange={(e) => onUpdate({ minWords: parseInt(e.target.value) || 0 })}
                        min="0"
                        style={{ 
                            width: '100%', 
                            padding: '8px', 
                            border: '1px solid #ddd', 
                            borderRadius: '6px' 
                        }}
                    />
                    <p style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>
                        Минимальное количество слов
                    </p>
                </div>

                <div>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', fontSize: '13px' }}>
                        Максимум слов
                    </label>
                    <input
                        type="number"
                        value={maxWords}
                        onChange={(e) => onUpdate({ maxWords: parseInt(e.target.value) || 0 })}
                        min="0"
                        style={{ 
                            width: '100%', 
                            padding: '8px', 
                            border: '1px solid #ddd', 
                            borderRadius: '6px' 
                        }}
                    />
                    <p style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>
                        Максимальное количество слов
                    </p>
                </div>

                <div>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', fontSize: '13px' }}>
                        Максимальный балл
                    </label>
                    <input
                        type="number"
                        value={maxPoints}
                        onChange={(e) => onUpdate({ maxPoints: parseInt(e.target.value) || 1 })}
                        min="1"
                        style={{ 
                            width: '100%', 
                            padding: '8px', 
                            border: '1px solid #ddd', 
                            borderRadius: '6px' 
                        }}
                    />
                    <p style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>
                        Максимальный балл за задание
                    </p>
                </div>
            </div>

            {/* Превью для студента */}
            <div>
                <h4 style={{ marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <FiFileText /> Превью для студента
                </h4>
                <div style={{ 
                    padding: '20px', 
                    background: 'white', 
                    border: '2px solid #e0e0e0', 
                    borderRadius: '8px'
                }}>
                    {taskDescription ? (
                        <>
                            <div style={{ 
                                whiteSpace: 'pre-wrap',
                                fontSize: '14px',
                                lineHeight: '1.6',
                                marginBottom: '15px',
                                color: '#333'
                            }}>
                                {taskDescription}
                            </div>
                            <div style={{ 
                                padding: '12px',
                                background: '#f0f8ff',
                                borderRadius: '6px',
                                fontSize: '13px',
                                color: '#666'
                            }}>
                                <strong>Требования:</strong>
                                <ul style={{ margin: '8px 0 0 0', paddingLeft: '20px' }}>
                                    {minWords > 0 && <li>Минимум слов: {minWords}</li>}
                                    {maxWords > 0 && <li>Максимум слов: {maxWords}</li>}
                                    <li>Максимальный балл: {maxPoints}</li>
                                </ul>
                            </div>
                            <div style={{ 
                                marginTop: '15px',
                                padding: '15px',
                                border: '1px solid #ddd',
                                borderRadius: '6px',
                                minHeight: '150px',
                                background: '#fafafa'
                            }}>
                                <p style={{ color: '#999', fontStyle: 'italic', margin: 0 }}>
                                    [Здесь студент будет писать свой текст...]
                                </p>
                            </div>
                        </>
                    ) : (
                        <p style={{ color: '#999', fontStyle: 'italic', textAlign: 'center', margin: 0 }}>
                            Введите описание задания выше, чтобы увидеть превью
                        </p>
                    )}
                </div>
            </div>

            {/* Подсказка для преподавателя */}
            <div style={{ 
                padding: '15px', 
                background: '#e6f7ff', 
                border: '1px solid #91d5ff', 
                borderRadius: '8px',
                fontSize: '12px',
                color: '#096dd9'
            }}>
                <strong>💡 Подсказка:</strong> После того, как студент завершит тест, 
                письменная работа появится в разделе "Проверка тестов". 
                Вы сможете оценить работу и дать обратную связь студенту.
            </div>
        </div>
    );
};

export default WritingBlockEditor;
